import { ValidationMessageProvider } from "./validation-message-provider";
import { Injectable } from "@angular/core";

@Injectable()
export class DefaultValidationMessageProvider extends ValidationMessageProvider {
  protected getRequiredError(): string {
    return "Please enter a value";
  }
  protected getPatternError(): string {
    return "Value does not match required pattern";
  }

  protected getMinError(min: number, actual: number): string {
    return `Please enter a value greater than or equal to ${min}.`;
  }
  protected getMaxError(max: number, actual: number): string {
    return `Please enter a value less than or equal to ${max}`;
  }

  protected getMinLengthError(
    requiredLength: number,
    actualLength: number
  ): string {
    return `Please enter at least ${requiredLength} characters.`;
  }
  protected getMaxLengthError(
    requiredLength: number,
    actualLength: number
  ): string {
    return `Please enter no more than ${requiredLength} characters.`;
  }
  protected getEmailFormatError(): string {
    return "Incorrect email format";
  }
  protected getPhoneFormatError(): string {
    return "Incorrect phone format";
  }
  protected getCustomValidatorError(
    validatorKey: string,
    message: any
  ): string {
    return typeof message === "string" ? message : validatorKey;
  }
}
